(function(){
  var root=document.querySelector('.kvtree');
  if(!root) return;

  // 1. Boekjes in de boom laten linken naar de juiste pagina
  var target=root.getAttribute('data-shop-url')||'/pages/wachtlijst';
  root.querySelectorAll('a[href$=".html"]').forEach(function(a){
    a.setAttribute('href',target);
    a.removeAttribute('style');
    a.setAttribute('class','kvbook');
  });

  // 2. Productbeelden vervangen door de transparante versies
  var swap={
    'kivi-product-lava.png':'kivi-product-lava-transparent.png',
    'kivi-product-verdigris.png':'kivi-product-verdigris-transparent.png'
  };
  root.querySelectorAll('image').forEach(function(im){
    var h=im.getAttribute('href')||im.getAttributeNS('http://www.w3.org/1999/xlink','href')||'';
    for(var k in swap){
      if(h.indexOf(k)>-1){
        var n=h.split('?')[0].replace(k,swap[k]);
        im.setAttribute('href',n);
        im.removeAttributeNS('http://www.w3.org/1999/xlink','href');
        break;
      }
    }
  });

  // 3. Teksten in de SVG vertalen. De boom-SVG is een vast bestand,
  //    dus de labels worden hier vervangen in plaats van in de bron.
  var t=(root.getAttribute('data-labels')||'').trim();
  if(t){
    var map={};
    t.split('|').forEach(function(pair){
      var i=pair.indexOf('=>');
      if(i>0) map[pair.slice(0,i).trim()]=pair.slice(i+2).trim();
    });
    root.querySelectorAll('text').forEach(function(el){
      var s=(el.textContent||'').trim();
      if(map[s]!==undefined) el.textContent=map[s];
    });
  }
})();
